import React from 'react';
import { Link } from 'react-router-dom';
import { handleScrollReset } from '@/utils/navigationUtils';

const HeaderNavigation: React.FC = () => {
  return (
    <nav className="hidden md:flex items-center space-x-6">
      {/* Empty nav since we removed all links for user dashboard */}
    </nav>
  );
};

export default HeaderNavigation;
